// Customer currency helpers. The customer's currency comes from the session
// payload (session.setting.currency). When it is absent the site behaves
// exactly as it always has: GBP with a £ symbol.

export const DEFAULT_CURRENCY_CODE = 'GBP'
export const DEFAULT_CURRENCY_SYMBOL = '£'

// Convert a GBP amount into the customer's currency for DISPLAY ONLY.
// exchangeRate is GBP per 1 unit of the customer's currency (e.g. 0.8519 for EUR),
// so customer-currency amount = GBP amount / rate. Returns null when no usable
// rate is available, so callers can show a "calculated on invoice" message instead.
export function convertFromGbp(amount, exchangeRate) {
  const rate = parseFloat(exchangeRate)
  if (!(rate > 0)) {
    return null
  }
  return (parseFloat(amount) || 0) / rate
}
